import auth from "@/middleware/auth";

export default [
    {
        path: "propostasFianca",
        name: "propostasFianca",
        meta: { middleware: [auth] },
        component: () => import("./PropostasFianca")
    }
];
